import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from 'react-i18next';
import styles from './card.module.css';

interface ChartInfoTooltipProps {
    description: string;
}

export const ChartInfoTooltip: React.FC<ChartInfoTooltipProps> = ({ description }) => {
    const { t } = useTranslation();

    if (!description) {
        return null;
    }

    // Check if the description is a translation key
    const tooltipText = description.startsWith('charts.') ? t(description) : description;

    return (
        <div className={styles.infoTooltip}>
            <Tooltip title={tooltipText}>
                <IconButton
                    size="small"
                    className={styles.infoIconButton}
                    aria-label={t('charts.infoTooltip')}
                >
                    <InfoIcon fontSize="small" />
                </IconButton>
            </Tooltip>
        </div>
    );
}; 